import React from 'react'

export const IconCircle = (props: React.SVGProps<SVGSVGElement>) => (
  <svg width="22" height="22" viewBox="0 0 22 22" fill="none" {...props}>
    <circle cx="11" cy="11" r="9" fill="currentColor" />
  </svg>
)
